// src/pages/ClarifyTopicsListPage.js
import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { Link } from 'react-router-dom';

export default function ClarifyTopicsListPage() {
  const [topics, setTopics] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const fetchTopics = async () => {
      const { data, error } = await supabase
        .from('clarify_topics')
        .select('id, name')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching clarify topics:', error);
      } else {
        setTopics(data);
      }
    };

    fetchTopics();
  }, []);

  const filtered = topics.filter((t) =>
    t.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h2 className="text-2xl font-bold text-center mb-6 text-indigo-700">📚 Clarification Topics</h2>

      <div className="mb-4 text-center">
        <input
          type="text"
          placeholder="Search topics..."
          className="w-full sm:w-96 px-4 py-2 border rounded shadow text-sm"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 text-sm">
          <thead className="bg-indigo-50 text-indigo-700">
            <tr>
              <th className="px-4 py-2 text-left">Topic Name</th>
              <th className="px-4 py-2 text-left">Topic ID</th>
              <th className="px-4 py-2 text-left">View</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((topic) => (
              <tr key={topic.id} className="border-t">
                <td className="px-4 py-2">{topic.name}</td>
                <td className="px-4 py-2 text-gray-500">{topic.id}</td>
                <td className="px-4 py-2">
                  <Link
                    to={`/clarify/${topic.id}`}
                    className="text-indigo-600 hover:underline"
                  >
                    Open Clarify Page
                  </Link>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center text-gray-400 py-6">
                  No topics found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
